import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <div className="footer__logo">
            <img
    src="/images/logo.png"
    alt="CozyRooms Logo"
    className="footer__logo-img"
  />
            <div>
              <span className="footer__logo-name">CozyRooms</span>
              <span className="footer__logo-tag">Luxury Ladies PG</span>
            </div>
          </div>

          <p className="footer__tagline">
            Premium ladies PG in Chinnapanna Halli offering safe, comfortable,
            and well-equipped living for women.
          </p>  
        </div>

        <div className="footer__nav">
          <h4 className="footer__heading">Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#amenities">Amenities</a></li>
            <li><a href="#rooms">Choice of Rooms</a></li>
            <li><a href="#gallery">Gallery</a></li>
            <li><a href="#contact">Booking & Contact</a></li>
          </ul>
        </div>

        <div className="footer__contact">
          <h4 className="footer__heading">Contact Us</h4>
          <ul>
            <li>
            <a href="https://maps.app.goo.gl/i4b8JUEkpTMx6cVL9"target="_blank"rel="noopener noreferrer">
              Plot 48, 4th Cross Rd, opposite Bagmane Solarium City Campus,
              Friends Layout, Chinnapanna Halli, Bengaluru, Karnataka 560037
            </a>
            </li>
            <li>
              <a href="tel:+917799871801">+91 7799871801</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__divider"></div>
        <div className="footer__bottom-inner">
          <p>© 2026 CozyRooms Luxury Ladies PG. All rights reserved.</p>
          <p>Designed for safe and comfortable living</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;